<template>
    <div class="overlay">
        <h2>Mehrfachaktionen</h2>
        <button type="button" class="btn btn-warning">Einem Kollege zuweisen</button>
        <button type="button" class="btn btn-warning" v-on:click="showGroupOverlay = !showGroupOverlay">Einer Gruppe
            zuweisen
        </button>
        <GroupOverlay v-if="showGroupOverlay"></GroupOverlay>
    </div>
</template>

<script>
    import fb from '../firebase/init';
    import GroupOverlay from "../components/GroupOverlay";

    export default {
        name: 'ChatsOverview',
        props: ['allGroupMessages', 'userId', 'userName'],
        components: {
            GroupOverlay,
        },
        data() {
            return {
                choosenChats: [],
                sidebar: false,
                showGroupOverlay: false,
            }
        },
        methods: {
            closeOverlay: function () {
                this.$emit('closeOverlay');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overlay {
        margin: 150px auto 30px;
        position: absolute;
        z-index: 50;
        width: 460px;
        background: #fffffe;
        border-radius: 15px;
        padding: 50px 10px 100px;
        box-shadow: 0 7px 15px 5px rgba(0, 0, 0, 0.1);
        right: 10%;
    }
</style>
